export const menpaiName = (menpai: number): string => {
    switch (menpai) {
        case 0:
          return "Thiếu Lâm";
        case 1:
          return "Minh Giáo";
        case 2:
          return "Cái Bang";
        case 3:
          return "Võ Đang";
        case 4:
          return "Nga My";
        case 5:
          return "Tinh Túc";
        case 6:
          return "Thiên Long";
        case 7:
          return "Thiên Sơn";
        case 8:
          return "Tiêu Dao";

        case 9:
          return "Không có";

        case 10:
          return "Mộ Dung";
        case 11:
          return "Đường Môn";
        case 12:
          return "Quỷ Cốc";
        case 13:
          return "Đào Hoa";
        case 14:
          return "Tuyệt Tình Cốc";
    }

    return "Chưa rõ";
};
